export interface SendFormData {
    folder: string;
    templateHTML: string;
    fromEmail: string;
    ToEmail: string;
    subject: string;
    name: string;
    email: string;
    phone: string;
    origen: string;
    attachments: Attachment[];
}

export interface Attachment {
    filename: string;
    cid: string;
}

import config from 'config';

const api_base = config.API_URL;

// Tipo para la respuesta de la API
interface ApiResponse {
    success: boolean;
    message?: string;
    data?: any;
}

// Función para enviar datos del formulario
export const sendFormData = async (data: SendFormData): Promise<ApiResponse> => {
    try {
        // Verificar si es FormData o JSON
        const isFormData = data instanceof FormData;
        
        // Configurar headers
        const headers: Record<string, string> = {};
        
        // Solo establecer Content-Type si no es FormData
        if (!isFormData) {
            headers['Content-Type'] = 'application/json';
        }
        
        // Preparar el body
        const body = isFormData ? data : JSON.stringify(data);
        console.log("API: ",api_base)
        const response = await fetch(`${api_base}`, {
            method: 'POST',
            headers,
            body,
            // Puedes descomentar esta línea si necesitas enviar cookies
            // credentials: 'include',
        });
        
        // Verificar si la respuesta es exitosa
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        // Intentar parsear JSON
        const result = await response.json();
        
        return {
            success: true,
            data: result,
        };
        
    } catch (error) {
        console.error('Error sending form data:', error);
        
        return {
            success: false,
            message: error instanceof Error ? error.message : 'Unknown error occurred',
        };
    }
};